window.axios = require('axios');
window.axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';

import fade from './modules/fade';
import scroll from './modules/scroll';
import menu from './modules/menu';
import collapsible from './modules/collapsable';
import form from './modules/form';
import tabs from './modules/tabs';
import voice from './modules/voice';
import shop from './modules/shop';
import search from './modules/search';

// --------------------------  LightBox
import baguetteBox from 'baguettebox.js';
baguetteBox.run('.page-gallery');

// --------------------------  Lazy Images
import LazyLoad from "vanilla-lazyload";
new LazyLoad();

scroll.scroll();

menu.mainMenu();

collapsible.collapsible();

tabs.tabs(fade);

voice.voiceSearch();

form.form();

shop.productFiltersHandler();
shop.productShopCart();
shop.productMiniShopCart();
shop.productListCart();

search.init();
